import { Image } from '@wome/ui'
import { CSSProperties } from 'react'

import s from './styles.module.scss'

import { HouseOwnerHouseFieldFragment } from '@/lib/graphql'

const MinHouse = ({
  house,
  style = {},
  badge = 0,
}: {
  house: HouseOwnerHouseFieldFragment
  style?: CSSProperties
  badge?: number
}) => (
  <div className={s.infoHouse} style={style}>
    <div className={s.imageHouse}>
      <Image
        src={
          house.pictures.length ? house.pictures[0].uri : '/default-wome.png'
        }
        type='cover'
        alt=''
      />
    </div>
    <div className={s.titleHouse}>{house.title}</div>
    {badge > 0 && <div className={s.badge}>{badge}</div>}
  </div>
)

export default MinHouse
